import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// Sentry — monitoreo de errores. El DSN del frontend es público por diseño.
// environment se deduce del host: en localhost = development, en prod = production.
const SENTRY_DSN =
  process.env.REACT_APP_SENTRY_DSN ||
  "https://1681f905b02eabe63fd38d03afae4d8a@o4511634641846272.ingest.us.sentry.io/4511634662162432";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: window.location.hostname === "localhost" ? "development" : "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<p>Ocurrió un error. Recargá la página.</p>}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Sentry.ErrorBoundary>,
);
